import { createEvent, createStore } from 'effector';
import { useUnit } from 'effector-react';

type Store = {
  categories?: string[];
  providers?: string[];
  sort: SelectedSort;
};

const setCategories = createEvent<string[]>();
const setProviders = createEvent<string[]>();
const setSort = createEvent<SelectedSort>();
const store = createStore<Store>({
  sort: { value: -1, name: 'popular' },
});

store.on(setCategories, (currentStore, categories) => ({
  ...currentStore,
  categories,
}));

store.on(setProviders, (currentStore, providers) => ({
  ...currentStore,
  providers,
}));

store.on(setSort, (currentStore, sort) => ({
  ...currentStore,
  sort,
}));

const useSelectedFiltersStore = () => ({
  ...useUnit(store),
  setCategories,
  setProviders,
  setSort,
});

export default useSelectedFiltersStore;
